/**
 * MapModule
 *
 * @module MapModule
 */
(function MapModule(){

    /**
     * Build a Map with markers
     * @param {jQuery} $wrapper
     * @param {array} markerData
     * @constructor
     */
    function Map($wrapper, markerData) {

        var that = this;

        /**
         * Path of the static resources
         * @type {string}
         */
        var resourcePath = "/_Resources/Static/Packages/TechDivision.Map/Icons/";

        /**
         * The container which is used for map rendering
         * @type {dom}
         */
        var mapContainer = $wrapper.querySelector('[data-tdmap="container"]');

        /**
         * The initial zoom, gets also used if none or only one marker is configured
         * @type {number}
         */
        var zoom = 5;

        var configuredZoom = $wrapper.getAttribute('data-tdmap-zoom');
        if(configuredZoom.length > 0 && !isNaN(configuredZoom)) {
            zoom = parseInt(configuredZoom, 10);

        }

        /**
         * Checks if the marker has text content or not
         * @param contentString
         * @returns {boolean}
         */
        this.hasMarkerContentText = function(contentString) {
            // parse the contentString as dom
            var parser = new DOMParser(),
                markerContent = parser.parseFromString(contentString, "text/xml");

            // get all elements
            var markerContentElements = markerContent.querySelectorAll('*');
            var totalLength = 0;
            // iterate all elements
            Array.prototype.forEach.call(markerContentElements, function(ele, i){
                totalLength = totalLength + ele.textContent.length;
            });
            return totalLength > 0;
        };

        var map = new google.maps.Map(mapContainer, {
            zoom: zoom,
            maxZoom: 17,
            center: {lat: 47.849920, lng: 12.058078},
            scrollwheel: TechDivisionMap.Context.isFrontend()
        });
        var latlngbounds = new google.maps.LatLngBounds();
        var infowindow = new google.maps.InfoWindow({
            content: ""
        });

        // build the markers
        var markers = markerData.map(function(markerData, i) {
            latlngbounds.extend(new google.maps.LatLng (markerData.latitude, markerData.longitude));
            var marker = new google.maps.Marker({
                position: {lat: markerData.latitude, lng: markerData.longitude}
            });
            marker.addListener('click', function() {

                if(that.hasMarkerContentText(markerData.content)) {
                    infowindow.setContent(markerData.content);
                    infowindow.open(map, marker);
                }
            });

            return marker;
        });
        map.setCenter(latlngbounds.getCenter());
        if(markers.length > 1) {
            map.fitBounds(latlngbounds);
        }

        // Add a marker clusterer to manage the markers
        var markerCluster = new MarkerClusterer(map, markers, {imagePath: resourcePath +'m'});
    }

    if (typeof document.addEventListener === 'function') {
        document.addEventListener('TechDivision.Map.apiInitialized', function(event) {
            var markerMapsDom = document.querySelectorAll('[data-tdmap-type="markermap"]');
            // iterate all map instances
            Array.prototype.forEach.call(markerMapsDom, function(markerMapDom, i){
                var markerMap = new Map(markerMapDom, window.TechDivisionMap.DataProvider.markerFromDom(markerMapDom));
            });
        });
    }

})();